import type { UseLalSegmentPermissions } from '@openx/components-segment/lib/utils/context/SegmentHookTypes';
import { useAuth } from '../../../components/AuthContext/context';
import { isInternalAdmin } from '../../../permissions/validators';

export const useLalSegmentPermissions: UseLalSegmentPermissions = () => {
  const { session } = useAuth();

  const shouldSeeOnBehalfOf = isInternalAdmin(session);

  return {
    shouldSeeOnBehalfOf,
  };
};
